import { render, staticRenderFns } from "./giftGalleryModel.vue?vue&type=template&id=0effe372&scoped=true"
import script from "./giftGalleryModel.vue?vue&type=script&lang=js"
export * from "./giftGalleryModel.vue?vue&type=script&lang=js"
import style0 from "./giftGalleryModel.vue?vue&type=style&index=0&id=0effe372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effe372",
  null
  
)

export default component.exports